module.exports = __webpack_public_path__ + "static/img/pause-voice.8395461.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pause-voice.png
// module id = aQSF
// module chunks = 1